export const WORKBOOK_CHANGED_KEY = 'workbook-changed';
